import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * Kontextuelle Hilfe-Tour fuer die ABWESENHEITS-Seite (`/absence`,
 * `AbsenceComponent` + `absence-calendar`). Gestartet ueber den `?`-Button in
 * der Kalender-Toolbar (FullCalendar-`help`-customButton, Pattern analog
 * `AVAILABILITY_CALENDAR_HELP_TOUR` / `STAFFING_BEDARFSPLAN_HELP_TOUR`).
 *
 * Erklaerend (nextCondition 'manual', Spotlight + Voice-Over). Fuenf Schritte,
 * keine Cues (jeder Schritt = ein Seitenbereich, Per-Step-Spotlight reicht).
 * Kernbotschaft am Schluss: nur GENEHMIGTE Abwesenheiten blockieren die
 * Schichtplanung.
 */
export const ABSENCE_CALENDAR_HELP_TOUR: TourConfig = {
  id: TourFeature.AbsenceCalendarHelp,
  version: 1,
  title: 'ABSENCE_CALENDAR_HELP_TOUR_TITLE',
  description: 'ABSENCE_CALENDAR_HELP_TOUR_DESC',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  triggerContext: {
    route: '/absence',
  },
  statePolicy: {
    allowReplay: true,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: false,
  },
  priority: 100,
  estimatedDurationSec: 90,
  category: 'feature-discovery',
  chapters: [
    {
      id: 'overview',
      title: 'ABSENCE_CALENDAR_HELP_TOUR_TITLE',
      steps: [
        {
          id: 'welcome',
          anchor: AnchorId.AbsenceView,
          spotlightAnchor: AnchorId.AbsenceView,
          title: 'TUTORIAL.ABSENCE_CALENDAR.WELCOME.TITLE',
          content: 'TUTORIAL.ABSENCE_CALENDAR.WELCOME.CONTENT',
          placement: 'bottom',
          nextCondition: 'manual',
          showNextButton: true,
          showPrevButton: false,
        },
        {
          id: 'requests',
          anchor: AnchorId.AbsenceRequestsPanel,
          spotlightAnchor: AnchorId.AbsenceRequestsPanel,
          title: 'TUTORIAL.ABSENCE_CALENDAR.REQUESTS.TITLE',
          content: 'TUTORIAL.ABSENCE_CALENDAR.REQUESTS.CONTENT',
          placement: 'right',
          nextCondition: 'manual',
          showNextButton: true,
          // Panel nur sichtbar bei offenen Antraegen + Genehmigungs-Recht.
          skipIf: () =>
            !document.querySelector('[onboardingAnchor="absence-requests-panel"]'),
        },
        {
          id: 'calendar',
          anchor: AnchorId.AbsenceCalendar,
          spotlightAnchor: AnchorId.AbsenceCalendar,
          title: 'TUTORIAL.ABSENCE_CALENDAR.CALENDAR.TITLE',
          content: 'TUTORIAL.ABSENCE_CALENDAR.CALENDAR.CONTENT',
          placement: 'top',
          nextCondition: 'manual',
          showNextButton: true,
          skipIf: () =>
            !document.querySelector('[onboardingAnchor="absence-calendar"]'),
        },
        {
          id: 'charts',
          anchor: AnchorId.AbsenceCharts,
          spotlightAnchor: AnchorId.AbsenceCharts,
          title: 'TUTORIAL.ABSENCE_CALENDAR.CHARTS.TITLE',
          content: 'TUTORIAL.ABSENCE_CALENDAR.CHARTS.CONTENT',
          placement: 'top',
          nextCondition: 'manual',
          showNextButton: true,
          skipIf: () =>
            !document.querySelector('[onboardingAnchor="absence-charts"]'),
        },
        {
          id: 'why',
          anchor: AnchorId.AbsenceView,
          spotlightAnchor: AnchorId.AbsenceView,
          title: 'TUTORIAL.ABSENCE_CALENDAR.WHY.TITLE',
          content: 'TUTORIAL.ABSENCE_CALENDAR.WHY.CONTENT',
          placement: 'bottom',
          nextCondition: 'manual',
          showNextButton: true,
        },
      ],
    },
  ],
};
